/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CardPatient_Patient = {
    readonly _id: string;
    readonly name: string | null;
    readonly firstname: string | null;
    readonly lastname: string | null;
    readonly medicalRecordNumber: string | null;
    readonly createdAt: unknown | null;
    readonly lastLogin: unknown | null;
    readonly dateOfBirth: {
        readonly day: number | null;
        readonly month: number | null;
        readonly year: number | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node">;
    readonly " $refType": "CardPatient_Patient";
};
export type CardPatient_Patient$data = CardPatient_Patient;
export type CardPatient_Patient$key = {
    readonly " $data"?: CardPatient_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CardPatient_Patient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CardPatient_Patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medicalRecordNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastLogin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientDateOfBirth",
      "kind": "LinkedField",
      "name": "dateOfBirth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "day",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "month",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_Node"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = 'b55ebe1999ab2b35f5ba2da01c9ecdf7';
export default node;
